import { render } from "./yflhc.vue?vue&type=template&id=4154f6e4&scoped=true"
import script from "./yflhc.vue?vue&type=script&lang=js"
export * from "./yflhc.vue?vue&type=script&lang=js"

import "./yflhc.vue?vue&type=style&index=0&id=4154f6e4&lang=scss&scoped=true"
import "./yflhc.vue?vue&type=style&index=1&id=4154f6e4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4154f6e4"]])

export default __exports__